import { render, staticRenderFns } from "./ModalProductLocation.vue?vue&type=template&id=05a369ea&lang=pug&"
import script from "./ModalProductLocation.vue?vue&type=script&lang=js&"
export * from "./ModalProductLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports